import { jsx as _jsx } from "react/jsx-runtime";
import { boxStyle } from '../Box/Box';
export function Container({ as: Tag = 'div', max = 'lg', children, className, style: extraStyle, ...boxProps }) {
    const style = {
        maxInlineSize: `var(--container-${max})`,
        marginInline: 'auto',
        width: '100%',
        ...boxStyle(boxProps),
        ...extraStyle,
    };
    return (_jsx(Tag, { className: className, style: style, children: children }));
}
//# sourceMappingURL=Container.js.map